import { render, staticRenderFns } from "./DocumentsItemViewer.vue?vue&type=template&id=6f7dfc77&"
import script from "./DocumentsItemViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentsItemViewer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsItemViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports